import * as yup from "yup";
import { WebLayout } from "../components/web-layout";
import { Formik, FormikProps, Form, Field, ErrorMessage } from "formik";
import { FormikErrorMessage } from "../components/formik-error-message";
import { Spinner } from "../components/spinner";
import { API } from "../../utils/AxiosInstance";
import { WithTranslation, withTranslation } from "react-i18next";
import React from "react";

interface State {
    email: string;
    password: string;
    confirm_password: string;
}

export class _Register extends React.Component<WithTranslation, State> {
    state: State = {
        email: "",
        password: "",
        confirm_password: "",
    };

    render() {
        const { t } = this.props;
        const schema = yup.object().shape({
            email: yup.string().email().required(t("is required")),
            password: yup
                .string()
                .min(8, t("has to be equal or longer than 8 characters!"))
                .required(t("is required")),
            confirm_password: yup
                .string()
                .test(
                    "match",
                    t("password do not match"),
                    function (confirm_password) {
                        return confirm_password == this.parent.password;
                    }
                )
                .required(t("is required")),
        });
        return (
            <WebLayout>
                <Formik
                    initialValues={this.state}
                    onSubmit={this.onSubmit}
                    validationSchema={schema}
                    render={(formikProps: FormikProps<State>) => (
                        <Form
                            placeholder={undefined}
                            onPointerEnterCapture={undefined}
                            onPointerLeaveCapture={undefined}
                        >
                            <div className="pb-4">
                                <Field
                                    type="email"
                                    name="email"
                                    placeholder={t("Email")}
                                    className="form-control"
                                />
                                <ErrorMessage
                                    name="email"
                                    component={FormikErrorMessage}
                                />
                            </div>
                            <div className="pb-4">
                                <Field
                                    type="password"
                                    name="password"
                                    placeholder={t("Password")}
                                    className="form-control"
                                />
                                <i className="text-xs">
                                    {t(
                                        "Must contain a letter, a number and a symbol. It must be at least 8 characters long."
                                    )}
                                </i>
                                <ErrorMessage
                                    name="password"
                                    component={FormikErrorMessage}
                                />
                            </div>
                            <div className="pb-4">
                                <Field
                                    type="password"
                                    name="confirm_password"
                                    placeholder={t("Retype Password")}
                                    className="form-control"
                                />
                                <ErrorMessage
                                    name="confirm_password"
                                    component={FormikErrorMessage}
                                />
                            </div>
                            <button
                                type="submit"
                                className="btn btn-success form-control"
                                disabled={formikProps.isSubmitting}
                            >
                                {" "}
                                {formikProps.isSubmitting && <Spinner />}{" "}
                                {t("REGISTER NOW!")}
                            </button>
                        </Form>
                    )}
                />
            </WebLayout>
        );
    }

    onSubmit = async (values: State, actions: any) => {
        try {
            await API.post("/pow_registrations", {
                email: values.email,
                password: values.password,
            });
            actions.setSubmitting(false);
            window.location.href = "/pow-success";
        } catch (error: any) {
            actions.setSubmitting(false);
            if (error.data && error.data.errors) {
                actions.setErrors(this.props.t(error.data.errors));
            } else {
                alert(error.message);
            }
        }
    };
}

export const Register = withTranslation()(_Register);
